import React from "react";
import { EvtSectionHeader } from "components/header";
import Integrationscard from "components/integration-card";
import { PROJECT_INTEGRATION_TYPES, useProject } from "../../../context";
import { useParams } from "react-router-dom";
import { useGithubData } from "@/modules/work/projects/integrations/components/github/useGithubData";
import { useDiscordData } from "@/modules/work/projects/integrations/components/discord/useDiscordData";
import { useDriveData } from "@/modules/work/projects/integrations/components/drive/useDriveData";
import { ROUTE } from "@/lib/utils";
import { LINKS, DISCORD_GUILD_ID } from "@/lib/utils";

export default function IntegrationsSection() {
  const { project_slug: projectSlug } = useParams();
  const { id } = useProject();

  const { githubRepos } = useGithubData(id);
  const { discordChannelIds } = useDiscordData(id);
  const { driveFolderIds } = useDriveData(id);
  if (
    discordChannelIds.length === 0 &&
    driveFolderIds.length === 0 &&
    githubRepos.length === 0
  ) {
    return null;
  }

  return (
    <section className="mt-2 pb-3">
      <EvtSectionHeader title="Integrations" />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 px-4 gap-4 md:px-6 mt-2.5">
        {discordChannelIds.map(({ channelId, chat_id, project_service_id }) => (
          <Integrationscard
            key={`discord-${chat_id}`}
            title={projectSlug}
            icon={PROJECT_INTEGRATION_TYPES.discord.icon}
            href={ROUTE.PROJECT_INTEGRATIONS_CHAT_SERVICE(
              projectSlug,
              project_service_id,
              chat_id
            )}
            link={LINKS.DISCORD_CHANNEL(DISCORD_GUILD_ID, channelId)}
          />
        ))}
        {driveFolderIds.map(({ folderId, drive_id, project_service_id }) => (
          <Integrationscard
            key={`drive-${drive_id}`}
            title={projectSlug}
            icon={PROJECT_INTEGRATION_TYPES.drive.icon}
            href={ROUTE.PROJECT_INTEGRATIONS_DRIVE_SERVICE(
              projectSlug,
              project_service_id,
              drive_id
            )}
            link={LINKS.DRIVE_FOLDER_WEB(folderId)}
          />
        ))}
        {githubRepos.map(
          ({ repository_url, suffix, repo_id, project_service_id }) => (
            <Integrationscard
              key={`github-${repository_url}`}
              title={suffix || projectSlug}
              icon={PROJECT_INTEGRATION_TYPES.github.icon}
              href={ROUTE.PROJECT_INTEGRATIONS_REPOSITORY_SERVICE(
                projectSlug,
                project_service_id,
                repo_id
              )}
              link={repository_url}
            />
          )
        )}
      </div>
    </section>
  );
}
